import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map, of } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../auth.service';

export const authGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const platformId = inject(PLATFORM_ID);

  // On the server, session status is unknown — allow the route and let the browser guard handle it
  if (!isPlatformBrowser(platformId)) {
    return of(true);
  }

  return authService.checkAuthStatus().pipe(
    map(authenticated => {
      if (!authenticated) {
        authService.redirectToSso();
        return false;
      }
      return true;
    })
  );
};
